export default __webpack_public_path__ + "static/media/search-icon.27c9f927.svg";